<template>
  <el-footer class="footer">
    <div class="footer-content">
      <div class="logo-section">
        <img src="/static/logo2.png" class="footer-logo">
      </div>
      <div class="links-grid">
        <!-- 产品 -->
        <div class="links-column">
          <span class="section-title">{{ t('footerProduct') }}</span>
          <router-link :to="{ name: 'ProductSearch', params: { type: 0 } }" class="footer-link">{{ t('ddr4') }}</router-link>
          <router-link :to="{ name: 'ProductSearch', params: { type: 1 } }" class="footer-link">{{ t('ddr5') }}</router-link>
          <router-link :to="{ name: 'ProductSearch', params: { type: 2 } }" class="footer-link">{{ t('laptop') }}</router-link>
          <router-link :to="{ name: 'ProductSearch', params: { type: 3 } }" class="footer-link">{{ t('rgb') }}</router-link>
        </div>

        <!-- 新闻 -->
        <div class="links-column">
          <span class="section-title">{{ t('footerNews') }}</span>
          <router-link to="/news" class="footer-link">{{ t('newsCompany') }}</router-link>
          <router-link to="/news" class="footer-link">{{ t('newsMedia') }}</router-link>
        </div>

        <!-- 支持 -->
        <div class="links-column">
          <span class="section-title">{{ t('footerSupport') }}</span>
          <router-link to="/ContactUs" class="footer-link">{{ t('supportService') }}</router-link>
          <router-link to="/ContactUs" class="footer-link">{{ t('faq') }}</router-link>
          <router-link to="/ContactUs" class="footer-link">{{ t('techSupport') }}</router-link>
        </div>

        <!-- 关于 -->
        <div class="links-column">
          <span class="section-title">{{ t('footerAbout') }}</span>
          <router-link to="/join" class="footer-link">{{ t('companyIntro') }}</router-link>
          <router-link to="/join" class="footer-link">{{ t('honors') }}</router-link>
          <router-link to="/join" class="footer-link">{{ t('milestones') }}</router-link>
          <router-link to="/join" class="footer-link">{{ t('culture') }}</router-link>
        </div>

        <!-- 加入 -->
        <div class="links-column">
          <span class="section-title">{{ t('footerJoin') }}</span>
          <router-link to="/join" class="footer-link">{{ t('joinUs') }}</router-link>
          <router-link to="/join" class="footer-link">{{ t('recruit') }}</router-link>
        </div>

        <!-- 联系 -->
        <div class="links-column">
          <span class="section-title contact-title">{{ t('footerContact') }}</span>
          <div class="contact-info">
            <div class="contact-item">{{ t('address') }}：{{address}}</div>
            <div class="contact-item">{{ t('email') }}：{{phone}}</div>
          </div>
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: ['t', 'address', 'phone']
};
</script>

<style scoped>
/* 基础样式 */
.footer {
  padding: 30px;
  background-image: url("/static/batter-bj.jpg") !important;
  text-align: center;
  width: 100%;
  height: 712px !important;
  display: flex;
  justify-content: center;
}

.footer-content {
  width: 70%;
  margin-top: 100px;
}

.logo-section {
  text-align: left;
  border-bottom: white solid 1px;
  height: 60px;
  margin-bottom: 30px;
}

.footer-logo {
  width: 182px;
  height: 40px;
}

.links-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(140px, max-content));
  justify-content: space-between;
  gap: 20px;
  text-align: left;
}

.links-column {
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  display: block;
  height: 30px;
  line-height: 30px;
}

.contact-title {
  font-size: 22px;
}

.footer-link {
  text-decoration: none;
  color: inherit;
  line-height: 40px;
  height: 40px;
  display: block;
}

.contact-info {
  //margin-top: 10px;
}

.contact-item {
  line-height: 40px;
  height: 40px;
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .footer {
    height: auto !important;
    min-height: 712px;
    padding: 20px 15px;
  }

  .footer-content {
    width: 100%;
    margin-top: 30px;
  }

  .logo-section {
    height: 50px;
    margin-bottom: 20px;
  }

  .footer-logo {
    width: 150px;
    height: 35px;
  }

  .links-grid {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }

  .links-column {
    margin-bottom: 15px;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 15px;
    height: 25px;
    line-height: 25px;
  }

  .contact-title {
    font-size: 18px;
  }

  .footer-link,
  .contact-item {
    line-height: 35px;
    height: 35px;
  }
}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .links-grid {
    grid-template-columns: 1fr 1fr;
  }

  .footer-link,
  .contact-item {
    line-height: 30px;
    height: 30px;
  }
}
</style>
